import React, { Component, useState } from 'react';
import { Redirect } from "react-router-dom";
import { toast } from 'react-toastify';
import SandboxedHtmlBody from './SandboxedHtmlBody.js';
import {SessionContext} from './SessionContext.js';
import {Section, safeHref, NOTES_MAX_CHARS} from '../Common.js';
import { copyToClipboard } from './PopupLookup/popupUtils.js';
import './AliasView.css';


class AliasDetails extends Component {
    state = {
        site_name: this.props.alias.site_name,
        custom_url: this.props.alias.custom_url,
        private_notes: this.props.alias.private_notes,
        alerts_enabled: this.props.alias.alerts_enabled,
        hidden: this.props.alias.hidden,
        blacklist_action: this.props.alias.blacklist_action
    }

    async handleAliasSave(e) {
        e.preventDefault();
        console.log("Saving alias settings")
    
        let alias = {
          "id": this.props.alias.id,
          "site_name": this.state.site_name,
          "custom_url": this.state.custom_url,
          "private_notes": this.state.private_notes,
          "alerts_enabled": this.state.alerts_enabled ? 1 : 0,
          "hidden": this.state.hidden ? 1: 0,
          "blacklist_action": this.state.blacklist_action
        }
        console.log(alias);
        try {
          await this.props.api.saveAlias(alias);
          // Refresh held count to ensure it's accurate after saving
          await this.props.api.refreshHeldCount(this.props.alias.id);
          toast.success(`Alias '${this.props.alias.alias}@nslmail.com' was saved successfully`, {onClick: () => {window.location.href=`/aliases/${this.props.alias.id}`}});
        } catch(e) {
          console.log(e.message);
          toast.error(e.message);
        }
        this.setState({redirect: '/aliases'});
    }
    handleAliasSave = this.handleAliasSave.bind(this);

    isArchived() {
        return this.state.alerts_enabled === 0 && 
               this.state.hidden === 1 && 
               this.state.blacklist_action === 1;
    }

    async handleArchive(e) {
        e.preventDefault();
        console.log("Archiving Alias");

        let alias = {
            "id": this.props.alias.id,
            "alerts_enabled": 0,
            "hidden": 1,
            "blacklist_action": 1
          }
          console.log(alias);
          try {
            await this.props.api.saveAlias(alias);
            // Refresh held count to ensure it's accurate after archiving
            await this.props.api.refreshHeldCount(this.props.alias.id);
            toast.success(`Alias '${this.props.alias.alias}@nslmail.com' has been archived`, {onClick: () => {window.location.href=`/aliases/${this.props.alias.id}`}});
          } catch(e) {
            console.log(e.message);
            toast.error(e.message);
          }
          this.setState({redirect: '/aliases'});        
    }
    handleArchive = this.handleArchive.bind(this);

    async handleUnarchive(e) {
        e.preventDefault();
        console.log("Unarchiving Alias");

        let alias = {
            "id": this.props.alias.id,
            "alerts_enabled": 1,
            "hidden": 0,
            "blacklist_action": -1
          }
          console.log(alias);
          try {
            await this.props.api.saveAlias(alias);
            // Refresh held count to ensure it's accurate after unarchiving
            await this.props.api.refreshHeldCount(this.props.alias.id);
            toast.success(`Alias '${this.props.alias.alias}@nslmail.com' has been unarchived`, {onClick: () => {window.location.href=`/aliases/${this.props.alias.id}`}});
          } catch(e) {
            console.log(e.message);
            toast.error(e.message);
          }
          this.setState({redirect: '/aliases'});        
    }
    handleUnarchive = this.handleUnarchive.bind(this);

    handleAliasCopy = () => {
        copyToClipboard(`${this.props.alias.alias}@nslmail.com`, toast.success);
    }

    render() {
        if (this.state.redirect)
            return <Redirect to={this.state.redirect} />

        return <Section name="Email Alias Details">
          <div className="card">
            <div className="card-content">
              <form onSubmit={this.handleAliasSave}>
                <div className="form-group">
                  <label className="form-label" htmlFor="siteName">Site Name</label>
                  <input
                    type="text"
                    id="siteName"
                    className="form-input"
                    value={this.state.site_name}
                    onChange={(e) => {this.setState({site_name: e.target.value})}}
                  />
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="siteUrl">Site URL</label>
                  <div className="flex items-center gap-2">
                    <input
                      type="text"
                      id="siteUrl"
                      className="form-input"
                      value={this.state.custom_url}
                      onChange={(e) => {this.setState({custom_url: e.target.value})}}
                    />
                    {/* Rendered as a link only when safeHref allows it. React 16
                        does not refuse a javascript: href; Chrome happens not to run
                        one in a target=_blank link, which is a browser behaviour
                        rather than anything this code guarantees. */}
                    {safeHref(this.state.custom_url) ? (
                      <a href={safeHref(this.state.custom_url)} target="_blank" rel="noopener noreferrer">
                        <img src="/images/external.png" alt="external" />
                      </a>
                    ) : (
                      <img src="/images/external.png" alt="" style={{ opacity: 0.4 }} />
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label">Alias</label>
                  <div 
                    className="alias-display clickable-alias"
                    onClick={this.handleAliasCopy}
                    title="Click to copy to clipboard"
                  >
                    {this.props.alias.alias}@nslmail.com
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="privateNotes">Private Notes</label>
                  <textarea
                    id="privateNotes"
                    className="form-input"
                    rows="5"
                    maxLength={NOTES_MAX_CHARS}
                    value={this.state.private_notes}
                    onChange={(e) => {this.setState({private_notes: e.target.value})}}
                  />
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="handleSpamBy">Handle Spam By</label>
                  <select
                    id="handleSpamBy"
                    className="form-input"
                    value={this.state.blacklist_action}
                    onChange={(e) => {this.setState({blacklist_action: e.target.value})}}
                  >
                    <option value={-1}>Use Global Setting</option>
                    <option value={0}>Prefixing Subject Line</option>
                    <option value={1}>Deleting Message</option>
                  </select>
                </div>

                <div className="form-group mb-6">
                  <table className="form">
                    <tbody>
                      <tr>
                        <td><label htmlFor="checkbox_alerts">Alert me of held messages</label></td>
                        <td><input id="checkbox_alerts" type="checkbox" checked={this.state.alerts_enabled} onChange={(e) => {this.setState({alerts_enabled: e.target.checked})}} /></td>
                      </tr>
                      <tr>
                        <td><label htmlFor="checkbox_hidden">Hide from main view</label></td>
                        <td><input id="checkbox_hidden" type="checkbox" checked={this.state.hidden} onChange={(e) => {this.setState({hidden: e.target.checked})}} /></td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="flex justify-center gap-4">
                  <button type="submit" className="btn btn-primary btn-lg">
                    Save
                  </button>
                  <button type="button" className="btn btn-secondary btn-lg" onClick={() => {this.setState({redirect: '/aliases'})}}>
                    Cancel
                  </button>
                  {this.isArchived() ? (
                    <button type="button" className="btn btn-success btn-lg" onClick={this.handleUnarchive}>
                      Unarchive
                    </button>
                  ) : (
                    <button type="button" className="btn btn-danger btn-lg" onClick={this.handleArchive}>
                      Archive
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </Section>
    }
}

let RuleList = (props) => {
    let body = "loading...";
    if (props.rules) {
        if (props.rules.length > 0) {
        let rules = props.rules.map(r =>
            <tr key={r.id} className="track">
                <td>{r.description}</td>
                <td>{r.message_count}</td>
                <td style={{textAlign: "right"}}><img src="/images/trash.gif" className="imgBtn" alt="delete" title="Delete Rule" onClick={() => {props.delete(r); return false;}}/></td>
            </tr>);
        body = <table className="list">
                <thead>
                <tr>
                    <th>Rule</th>
                    <th>Count</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                    {rules}
                </tbody>
            </table>
        } else {
            body = <div className="none">- none -</div>
        }
    }
    return <Section name={props.title}>{body}</Section>
}

let AddressBook = (props) => {
    let body = "loading...";
    if (props.addresses) {
        if (props.addresses.length > 0) {
            let addresses = props.addresses.map(a =>
                <tr key={a.id}>
                    <td>{a.cached_from_address}</td>
                    <td>{a.message_count}</td>
                    <td>{a.spam_count}</td>
                    <td></td>
                </tr>);
            body = <table className="list">
                    <thead>
                    <tr>
                        <th>Address</th>
                        <th>Count</th>
                        <th>Spam</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                        {addresses}
                    </tbody>
                </table>
        } else {
            body = <div className="none">- none -</div>
        }
    }
    return <Section name="Address Book">{body}</Section>
}

let Address = (props) => {
    if (props.address.name) {
        return <span>{props.address.name} &lt;{props.address.address}&gt;</span>;
    } else {
        return <span>{props.address.address}</span>;
    }
}

let HeldMessage = (props) => {
    const [isExpanded, setIsExpanded] = useState(false);
    
    const extractDomain = (email) => {
        const match = email.match(/@(.+)/);
        return match ? match[1] : email;
    };

    const handleAllow = async () => {
        const domains = [];
        
        // Add Reply-To domain if it exists
        if (props.message.replyTo && props.message.replyTo.address) {
            domains.push(extractDomain(props.message.replyTo.address));
        }
        
        // Add From domain if it exists and is different from what we already have
        if (props.message.from && props.message.from.address) {
            const fromDomain = extractDomain(props.message.from.address);
            if (!domains.includes(fromDomain)) {
                domains.push(fromDomain);
            }
        }
        
        // Ensure we have at least one domain
        if (domains.length === 0) {
            toast.error("Could not extract sender domains from message");
            return;
        }
        
        try {
            await props.onAllow(props.message.id, domains);
            const domainText = domains.length > 1 ? domains.join(", ") : domains[0];
            toast.success(`Allowed messages from ${domainText}`);
        } catch (e) {
            toast.error(`Error allowing message: ${e.message}`);
        }
    };

    const handleBlock = async () => {
        const domains = [];

        // Add Reply-To domain if it exists
        if (props.message.replyTo && props.message.replyTo.address) {
            domains.push(extractDomain(props.message.replyTo.address));
        }

        // Add From domain if it exists and is different from what we already have
        if (props.message.from && props.message.from.address) {
            const fromDomain = extractDomain(props.message.from.address);
            if (!domains.includes(fromDomain)) {
                domains.push(fromDomain);
            }
        }

        // Ensure we have at least one domain
        if (domains.length === 0) {
            toast.error("Could not extract sender domains from message");
            return;
        }

        try {
            await props.onBlock(props.message.id, domains);
            const domainText = domains.length > 1 ? domains.join(", ") : domains[0];
            toast.success(`Blocked messages from ${domainText}`);
        } catch (e) {
            toast.error(`Error blocking message: ${e.message}`);
        }
    };

    const handleDelete = async () => {
        try {
            await props.onDelete(props.message.id);
            toast.success("Message deleted");
        } catch (e) {
            toast.error(`Error deleting message: ${e.message}`);
        }
    };

    const renderExpandedContent = () => {
        if (!isExpanded) return null;
        
        const message = props.message;
        
        
        if (message.hasHtml && message.htmlContent && message.htmlContent.trim()) {
            // Held messages come from senders no whitelist has ever matched, and
            // nothing sanitises them server-side, so this is the most hostile
            // content the app renders. Same sandbox as the inbox.
            return (
                <div className="message-content-expanded">
                    <div className="message-content-type">HTML Content</div>
                    <SandboxedHtmlBody
                        className="message-html-content"
                        html={message.htmlContent}
                        title="Held message body"
                    />
                </div>
            );
        } else {
            return (
                <div className="message-content-expanded">
                    <div className="message-content-type">Plain Text Content</div>
                    <div className="message-plain-content">
                        {message.plainContent || message.preview}
                    </div>
                </div>
            );
        }
    };

    return <div className="held-message">
        <div className="message-actions">
            <button className="button allow-button" onClick={handleAllow}>Allow</button>
            <button className="button block-button" onClick={handleBlock}>Block</button>
            <button className="button delete-button" onClick={handleDelete}>Delete</button>
        </div>
        <b>From:</b> <Address address={props.message.from} /><br/>
        <b>Reply-To:</b> <Address address={props.message.replyTo} /><br/>
        <b>Subject:</b> {props.message.subject}<br/>
        <div className="message-preview-container">
            <div className="message-preview" onClick={() => setIsExpanded(!isExpanded)}>
                {props.message.preview}
                <div className="message-expand-hint">
                    {isExpanded ? '▼ Click to collapse' : '▶ Click to expand full message'}
                    {props.message.hasHtml && ' (Contains HTML)'}
                </div>
            </div>
            {renderExpandedContent()}
        </div>
    </div>
}

let HeldMessages = (props) => {
    let body = "loading...";
    if (props.messages) {
        if (props.messages.length > 0) {
            body = props.messages.map(m =>
                <HeldMessage
                    key={m.id}
                    message={m}
                    onAllow={props.onAllow}
                    onBlock={props.onBlock}
                    onDelete={props.onDelete}
                />
            );
        } else {
            body = <div className="none">- no held messages -</div>;
        }
    }
    return <Section name="Held Messages">{body}</Section>
}


class AliasView extends Component {
    static contextType = SessionContext;

    state = {
    }

    async componentDidMount() {
      console.log("Mounting: AliasView");
      this.API = this.context.actions.getAPI();
      let aliasId = this.props.match.params.aliasId;

      let held = await this.API.getHeldMessages(aliasId);
      //console.log("Held", held);
      this.setState({heldMessages: held});

      let alias = await this.API.getAlias(aliasId);
      console.log("Alias", alias);
      this.setState({alias: alias});

      let whitelist = await this.API.getWhitelistRules(aliasId);
      //console.log("Whitelist", whitelist);
      this.setState({whitelistRules: whitelist});

      let blacklist = await this.API.getBlacklistRules(aliasId);
      //console.log("Blacklist", blacklist);
      this.setState({blacklistRules: blacklist});

      let addresses = await this.API.getAddressMap(aliasId);
      //console.log("Addresses", addresses);
      this.setState({addresses: addresses});
    }


    async deleteWhitelistRule(rule) {
        let aliasId = this.props.match.params.aliasId;
        if (window.confirm("Are you sure you want to delete rule '" + rule.description + "'?")) {      
          try {
            await this.API.deleteWhitelistRule(aliasId, rule.id);
            toast.info("Deleted rule '" + rule.description + "'");
          } catch(e) {
            console.log(e);
            toast.error('Error deleting rule. Try again later.');
          }
          let whitelist = await this.API.getWhitelistRules(aliasId);
          this.setState({whitelistRules: whitelist});
        }
    }
    deleteWhitelistRule = this.deleteWhitelistRule.bind(this);

    async deleteBlacklistRule(rule) {
        console.log("Delete blacklist rule", rule);
        let aliasId = this.props.match.params.aliasId;
        if (window.confirm("Are you sure you want to delete rule '" + rule.description + "'?")) {      
          try {
            await this.API.deleteBlacklistRule(aliasId, rule.id);
            toast.info("Deleted rule '" + rule.description + "'");
          } catch(e) {
            console.log(e);
            toast.error('Error deleting rule. Try again later.');
          }
          let blacklist = await this.API.getBlacklistRules(aliasId);
          this.setState({blacklistRules: blacklist});
        }
    }
    deleteBlacklistRule = this.deleteBlacklistRule.bind(this);

    async allowHeldMessage(messageId, domains) {
        let aliasId = this.props.match.params.aliasId;
        try {
            await this.API.allowHeldMessage(aliasId, messageId, domains);
            // Refresh held messages after allowing
            let held = await this.API.getHeldMessages(aliasId);
            this.setState({heldMessages: held});
            // Refresh whitelist rules to show the new rule
            let whitelist = await this.API.getWhitelistRules(aliasId);
            this.setState({whitelistRules: whitelist});
            // Update the global aliases held count badge
            await this.context.actions.loadAliasesHeldCount();
            // Auto-refresh mail counter after 2 seconds
            setTimeout(() => {
                this.context.actions.loadMessageCount();
            }, 2000);
        } catch (e) {
            throw e;
        }
    }
    allowHeldMessage = this.allowHeldMessage.bind(this);

    async blockHeldMessage(messageId, domains) {
        let aliasId = this.props.match.params.aliasId;
        try {
            await this.API.blockHeldMessage(aliasId, messageId, domains);
            // Refresh held messages after blocking
            let held = await this.API.getHeldMessages(aliasId);
            this.setState({heldMessages: held});
            // Refresh blacklist rules to show the new rule
            let blacklist = await this.API.getBlacklistRules(aliasId);
            this.setState({blacklistRules: blacklist});
            // Update the global aliases held count badge
            await this.context.actions.loadAliasesHeldCount();
        } catch (e) {
            throw e;
        }
    }
    blockHeldMessage = this.blockHeldMessage.bind(this);

    async deleteHeldMessage(messageId) {
        let aliasId = this.props.match.params.aliasId;
        try {
            await this.API.deleteHeldMessage(aliasId, messageId);
            // Refresh held messages after deleting
            let held = await this.API.getHeldMessages(aliasId);
            this.setState({heldMessages: held});
            // Update the global aliases held count badge
            await this.context.actions.loadAliasesHeldCount();
        } catch (e) {
            throw e;
        }
    }
    deleteHeldMessage = this.deleteHeldMessage.bind(this);

    render() {
        return <div className="alias-view">
            {this.state.heldMessages && <HeldMessages
                api={this.API}
                messages={this.state.heldMessages}
                onAllow={this.allowHeldMessage}
                onBlock={this.blockHeldMessage}
                onDelete={this.deleteHeldMessage}
            />}

            {this.state.alias && <AliasDetails api={this.API} alias={this.state.alias} />}            

            {this.state.whitelistRules && <RuleList api={this.API} title="Whitelist Rules" rules={this.state.whitelistRules} delete={this.deleteWhitelistRule} />}

            {this.state.blacklistRules && <RuleList api={this.API} title="Blacklist Rules" rules={this.state.blacklistRules} delete={this.deleteBlacklistRule} />}

            {this.state.addresses && <AddressBook api={this.API} addresses={this.state.addresses} />}

        </div>
    }

  }

  export default AliasView;